import React from 'react';
import PropTypes from 'prop-types';
import { ENTITLEMENTS_PLATFORM_TYPES } from '@adsk/alloy-provider';
import { Box, Flex } from '@adsk/alloy-react-box';
import { LogoAutodeskAccIcon, LogoAutodeskBim360Icon } from '@adsk/alloy-react-icon';
import { MenuItem } from '@adsk/alloy-react-menu';
import theme from '@adsk/alloy-react-theme';
import HighlightedItemText from './HighlightedItemText';
import { MFAIcon } from './MFAIcon';
import getAnchorTarget from '../helpers/getAnchorTarget';
import getProjectUrl from '../helpers/getProjectUrl';
import { projectShape } from '../helpers/propTypes';
const ProjectListTemplateItem = _ref => {
  let {
    item: template,
    search,
    currentProjectId,
    currentProductId,
    onClose,
    onProjectClick,
    handleAnalyticOnClick,
    containerRef
  } = _ref;
  const id = template.id;
  const url = getProjectUrl(template, currentProductId);
  const highlighted = currentProjectId === id;
  const LogoComponent = template.platform === ENTITLEMENTS_PLATFORM_TYPES.ACC ? LogoAutodeskAccIcon : LogoAutodeskBim360Icon;
  return /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "template-item ".concat(highlighted ? 'highlighted' : ''),
    rel: "noreferrer noopener",
    highlighted: highlighted,
    showSelection: false,
    as: onProjectClick ? 'button' : 'a',
    href: url,
    target: getAnchorTarget(url),
    onClick: () => {
      onProjectClick === null || onProjectClick === void 0 ? void 0 : onProjectClick(template);
      handleAnalyticOnClick === null || handleAnalyticOnClick === void 0 ? void 0 : handleAnalyticOnClick(template);
      onClose === null || onClose === void 0 ? void 0 : onClose();
    },
    style: {
      height: 64,
      padding: '8px 16px',
      textAlign: 'initial'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    maxWidth: "250px"
  }, /*#__PURE__*/React.createElement(Box, {
    typography: "heading4",
    color: highlighted ? 'white' : 'charcoal900',
    ellipsis: "multi"
  }, /*#__PURE__*/React.createElement(HighlightedItemText, {
    text: template.name,
    search: search,
    highlighted: highlighted
  })), /*#__PURE__*/React.createElement(Box, {
    typography: "caption",
    color: highlighted ? 'white' : 'charcoal600',
    ellipsis: "single"
  }, template.accountName)), template.mfaBlocked && /*#__PURE__*/React.createElement(MFAIcon, {
    containerRef: containerRef
  }))), /*#__PURE__*/React.createElement(LogoComponent, {
    size: 16,
    style: {
      color: highlighted ? theme.colors.white : theme.colors.acsLogoBlue,
      marginLeft: theme.spacing.medium
    }
  })));
};
ProjectListTemplateItem.displayName = 'ProjectListTemplateItem';
ProjectListTemplateItem.propTypes = {
  /** The template item to show */
  item: projectShape,
  /** current selected project id */
  currentProjectId: PropTypes.string,
  /** current product ID, to check if project has entitlements for or not */
  currentProductId: PropTypes.string,
  /** menu close handler */
  onClose: PropTypes.func,
  /** project click handler */
  onProjectClick: PropTypes.func
};
export default ProjectListTemplateItem;
//# sourceMappingURL=ProjectListTemplateItem.js.map